export default "__VITE_ASSET__DnRCYD71__"